<template>
  <BaseModal
    :show="show"
    overflow-visible
    class="sm:overflow-visible"
    @close="close"
  >
    <template slot="header">
      Edit Membership Groups
    </template>
    <template slot="body">
      <MembershipGroupSelector
        class="mb-6"
        :pre-selected-groups="preSelectedGroups"
        @input="handleGroupSelection"
      />
    </template>
    <template slot="confirm">
      <button
        type="button"
        class="btn"
        @click="confirm"
        v-text="'Confirm'"
      />
    </template>
  </BaseModal>
</template>

<script type="text/babel">
import { mapActions } from 'vuex'
import MembershipGroupSelector from 'Membership/Resources/assets/js/components/utilities/MembershipGroupListSelector'

export default {
  name: 'CommunicationCategoryMembershipGroupModal',
  components: {
    MembershipGroupSelector,
  },
  data() {
    return {
      selectedMembershipGroups: [],
      preSelectedGroups: [],
    }
  },
  computed: {
    show() {
      return this.$root.openedModalId === 'communicationCategoryMembershipGroupModal'
    },
    modalPayload() {
      return this.$root.openedModal.payload
    },
  },
  watch: {
    modalPayload() {
      if (this.modalPayload) {
        this.preSelectedGroups = this.modalPayload.membershipGroups.data
        this.selectedMembershipGroups = this.preSelectedGroups
      }
    },
  },
  methods: {
    ...mapActions({
      saveMembershipGroups: 'communicationSetCommunicationCategoryMembershipGroups',
    }),
    confirm() {
      this.saveMembershipGroups({
        communicationCategoryUuid: this.$root.openedModal.payload.uuid,
        membershipGroupUuids: _.map(this.selectedMembershipGroups, 'uuid'),
      })
        .then((response) => {
          this.$store.commit('baseAddNotification', {
            type: 'success',
            title: 'Success',
            text: response.data.message,
          })

          this.$emit('update')

          this.close()
        })
    },
    close() {
      this.$root.closeModal()
        .then(() => {
          this.selectedMembershipGroups = []
        })
    },
    handleGroupSelection(groups){
      this.selectedMembershipGroups = groups
    },
  },
}
</script>
